module.exports = __webpack_public_path__ + "img/header-img.e7e26e9c.jpg";